/**
 * @generated SignedSource<<b9971a6e72b00c2d8a928e0f7d08e6fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultPagesPage$data = {
  readonly body: {
    readonly json: Schema | null | undefined;
  } | null | undefined;
  readonly entityId: string;
  readonly headline: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent">;
  readonly " $fragmentType": "defaultPagesPage";
};
export type defaultPagesPage$key = {
  readonly " $data"?: defaultPagesPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultPagesPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultPagesPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "body",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    }
  ],
  "type": "Page",
  "abstractKey": null
};

(node as any).hash = "c7ab1f5e158a51188f11241b4f5675ba";

export default node;
